import { useEffect, useState } from 'react';

import EventBusInstance from '@core/eventbus';

const useAttributeChange = (selector: string, attributeName: string) => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    const targetElement = document.querySelector(selector);
    if (!targetElement) return;

    const updateValue = () => {
      const newValue = targetElement.getAttribute(attributeName);

      if (newValue !== value) {
        setValue(newValue);
        EventBusInstance.dispatch('ab-refresh');
      }
    };

    const observer = new MutationObserver(updateValue);
    observer.observe(targetElement, {
      attributes: true,
      childList: false,
      subtree: false,
    });

    updateValue();

    return () => {
      observer.disconnect();
    };
  }, [selector, attributeName, value]);

  return value;
};

export default useAttributeChange;
